/**
 * Detects whether a URL hash comes from a Supabase recovery (invite/reset)
 * redirect, e.g. "#access_token=...&type=recovery".
 */
export function isRecoveryHash(hash: string | null | undefined): boolean {
  if (typeof hash !== "string" || hash.length < 2) return false;
  const params = new URLSearchParams(hash.replace(/^#/, ""));
  return params.get("type") === "recovery";
}
